// client/src/config/config.js
if (!process.env.REACT_APP_API_URL) {
  console.warn('REACT_APP_API_URL is not set. API requests will use relative paths.');
}

const config = {
  apiUrl: process.env.REACT_APP_API_URL || ''
};

export default config;